import { gql } from '@apollo/client';

export const CUSTOMER_STATEMENT_QUERY = gql`
  query CustomerStatementReport($customer_id: ID!) {
    customerStatementReport(customer_id: $customer_id) {
      customer {
        id
        full_name
        phone
        email
      }
      generated_at
      summary {
        tickets_count
        liquidados_count
        parciales_count
        pendientes_count
        sin_saldo_count
        subtotal_cents
        tax_cents
        total_cents
        paid_cents
        pending_cents
        overall_condition
      }
      tickets {
        sale_order_id
        ticket_label
        created_at
        pet_name
        status
        condition
        subtotal_cents
        tax_cents
        total_cents
        paid_cents
        pending_cents
        lines {
          item_code
          item_name
          quantity
          unit_price_cents
          total_cents
        }
      }
    }
  }
`;
